import rdf from '@ontologies/core';
import { createLineParser } from './createLineParser';
export const hextupleStringParser = (bodyString, rdfFactory = rdf) => {
    const lineToQuad = createLineParser(rdfFactory);
    const delta = [];
    for (const line of bodyString.split("\n")) {
        if (line.length > 0) {
            delta.push(lineToQuad(JSON.parse(line)));
        }
    }
    return delta;
};
